import { createFileRoute } from '@tanstack/react-router'

import { UnsExplorer } from '@/components/UnsExplorer'

export const Route = createFileRoute('/_app/logistics/explorer')({
  component: LogisticsExplorerPage,
})

function LogisticsExplorerPage() {
  return (
    <UnsExplorer
      wsAddress={import.meta.env.VITE_SHARED_WS_ADDRESS}
      username={import.meta.env.VITE_WS_USERNAME}
      password={import.meta.env.VITE_WS_PASSWORD}
      rootName="HPSCorp"
      topicFilters="HPSCorp/#"
      clientIdPrefix="stories_uns_logistics"
    />
  )
}
